import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Estate from '@/components/Estate'
import EstateSale from '@/components/EstateSale'
import EstateDetail from '@/components/EstateDetail'
import Search from '@/components/Search'
import City from '@/components/City'
import Calculate from '@/components/Calculate'
import FindHouse from '@/components/FindHouse'
import Recommend from '@/components/Recommend'
import Recommend1 from '@/components/Recommend1'
import Recommend2 from '@/components/Recommend2'
import Album from '@/components/Album'
import HouseType from '@/components/HouseType'
import NewsDetail from '@/components/NewsDetail'
import MapDetail from '@/components/MapDetail'
import AboutUs from '@/components/AboutUs'
import RecommendList from '@/components/RecommendList'
import RecommendSingle from '@/components/RecommendSingle'
import RecommendSingle1 from '@/components/RecommendSingle1'

Vue.use(Router)

function getAbsolutePath () {
    var cityCode = '/'
    var domain = window.location.hostname;


    var flag = false;
    if(domain.split('.')[0]=='m' || domain.indexOf('www.')>-1){
        if(domain.indexOf('qqbdc')>-1 || domain.indexOf('cqsuxu')>-1){
            cityCode = 'sz';
        }
        if(domain.indexOf('metianxia')>-1){
            cityCode = 'sz';
        }
        if(domain.indexOf('mtxfang')>-1 || domain.indexOf('hbaichi')>-1){
            cityCode = 'sz';
        }

        if(domain.indexOf('mdrfang')>-1){
            cityCode = 'sz';
        }
        //取跟路径下第一个斜杠后的城市简称
        var path = window.location.pathname.split('/');
        if(path[1]!=null && path[1]!=''){
            if(path[1]=='city'){
                cityCode = '/';
            }else{
                cityCode = path[1];
            }
        }
    }else if(domain.split('.')[0]=='xx'){
        if(domain.indexOf('hbaichi')>-1){
          cityCode = 'sz';
        }
        //取跟路径下第一个斜杠后的城市简称
        var path = window.location.pathname.split('/');
        if(path[1]!=null && path[1]!=''){
          if(path[1]=='city'){
            cityCode = '/';
          }else{
            cityCode = path[1];
          }
        }
    }else if(domain.split('.')[0]=='hzxy'){
        if(domain.indexOf('cqsuxu')>-1){
          cityCode = 'sz';
        }
        //取跟路径下第一个斜杠后的城市简称
        var path = window.location.pathname.split('/');
        if(path[1]!=null && path[1]!=''){
          if(path[1]=='city'){
            cityCode = '/';
          }else if(path[1]=='xyfc'){
            cityCode = path[2];
          }else{
            cityCode = path[1];
          }
        }
    }else{
          var path = domain.split('.');
          if(path[0].length>1){
              cityCode = path[0];
              flag = true;
          }
    }



    //放入缓存 main.js中需要用到切换城市
    localStorage.setItem('cityCode',cityCode);
    //pc的时候不需要赋值根目录
    if(flag){
        cityCode ='/';
    }
    return cityCode;
  }

export default new Router({
    linkActiveClass:'',
    linkExactActiveClass:'active',
    mode: 'history',
    base: getAbsolutePath(),
    routes: [
        { path: '/', component: Home},
        { path: '/estate', component: Estate, name:'estate' },
        { path: '/estateSale', component: EstateSale },
        { path: '/estateDetail', component: EstateDetail },
        { path: '/search', component: Search },
        { path: '/city', component: City, name:'city' },
        { path: '/calculate', component: Calculate },
        { path: '/findHouse', component: FindHouse },
        { path: '/recommend', component: Recommend },
        { path: '/recommend1', component: Recommend1 },
        { path: '/recommend2', component: Recommend2 },
        { path: '/album', component: Album, name:'album' },
        { path: '/houseType', component: HouseType, name:'houseType' },
        { path: '/newsDetail', component: NewsDetail, name:'newsDetail' },
        { path: '/mapDetail', component: MapDetail, name:'MapDetail' },
        { path: '/aboutUs', component: AboutUs, name:'AboutUs'},
        { path: '/recommendList', component: RecommendList },
        { path: '/recommendSingle', component: RecommendSingle },
        { path: '/recommendSingle1', component: RecommendSingle1 },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js